(function () {
  'use strict';

  var selector = '[data-blu-iwt-swiper]';

  function elementsIn(root) {
    var elements = [];

    if (root && root.matches && root.matches(selector)) {
      elements.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll(selector).forEach(function (element) {
        elements.push(element);
      });
    }

    return elements;
  }

  function initSwiper(element) {
    if (!element || element.swiper || element.dataset.bluSwiperInitialized === 'true') {
      return;
    }

    if (typeof window.Swiper !== 'function') {
      console.error('[BLU Swiper] Swiper library not found. Load swiper-bundle.min.js before blu-swiper-sections.js.');
      return;
    }

    var slideCount = parseInt(element.dataset.slideCount || '0', 10);
    var requestedLoop = element.dataset.loop === 'true';
    var loop = requestedLoop && slideCount > 1 && !(window.Shopify && window.Shopify.designMode);
    var speed = parseInt(element.dataset.speed || '500', 10);
    var prevEl = element.querySelector('.swiper-button-prev');
    var nextEl = element.querySelector('.swiper-button-next');
    var paginationEl = element.querySelector('.swiper-pagination');

    new window.Swiper(element, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      speed: speed,
      loop: loop,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      grabCursor: slideCount > 1,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide'
      },
      navigation: slideCount > 1 && prevEl && nextEl ? {
        prevEl: prevEl,
        nextEl: nextEl,
        addIcons: false
      } : false,
      pagination: slideCount > 1 && paginationEl ? {
        el: paginationEl,
        type: 'bullets',
        clickable: true
      } : false
    });

    element.dataset.bluSwiperInitialized = 'true';
  }

  function initAll(root) {
    elementsIn(root || document).forEach(initSwiper);
  }

  function destroyAll(root) {
    elementsIn(root).forEach(function (element) {
      if (element.swiper && typeof element.swiper.destroy === 'function') {
        element.swiper.destroy(true, true);
      }
      delete element.dataset.bluSwiperInitialized;
    });
  }

  function initWhenReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      }, { once: true });
    } else {
      initAll(document);
    }
  }

  initWhenReady();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target && event.target.closest ? event.target.closest('.blu-iwt-swiper .swiper-slide') : null;
    if (!slide) return;

    var swiperElement = slide.closest('[data-blu-iwt-swiper]');
    if (!swiperElement || !swiperElement.swiper) return;

    var slides = Array.prototype.slice.call(swiperElement.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    var index = slides.indexOf(slide);

    if (index >= 0) {
      swiperElement.swiper.slideTo(index, 0);
    }
  });
})();
